export default [
    {
      reducerKey: 'advertisers-list',
      sagaKey: 'advertisersListSaga',
      importReducer: () => import(/* webpackChunkName: "domain-advertisers" */ 'modules/Advertisers/List/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-advertisers" */ 'modules/Advertisers/List/store/saga'),
    },
    {
      sagaKey: 'advertiserCreateSaga',
      importSaga: () => import(/* webpackChunkName: "domain-advertisers" */ 'modules/Advertisers/Create/store/saga'),
    },
]
